import { ChatQueries } from './queries';
import { ChatMutations } from './mutations';

export const Chat = {
  queries: ChatQueries,
  mutations: ChatMutations,
};
